import { LEGAL_LAST_UPDATED } from '@/constants/site.constants';
import { CHILD_SAFETY_CONTENT } from '@/features/legal/constants/childSafety.constants';
import { useDocumentTitle } from '@/hooks/useDocumentTitle.hook';
import type { LegalDocumentContent } from '@/types/legal.types';

interface UseChildSafetyPageResult {
  content: LegalDocumentContent;
  lastUpdated: string;
}

export const useChildSafetyPage = (): UseChildSafetyPageResult => {
  useDocumentTitle(
    'Child Safety Standards | Shoutt',
    'How Shoutt prevents child sexual abuse and exploitation, how to report it, and who to contact.',
  );

  return { content: CHILD_SAFETY_CONTENT, lastUpdated: LEGAL_LAST_UPDATED };
};
